import type { GTMEventReturnType } from '../GTM.types';
import GTMBaseModel from '../GTMBaseModel';

interface GTMOverviewFilterAddModelReturnType extends GTMEventReturnType {
    filter_label: string;
    filter_group: string;
}

interface GTMOverviewFilterAddModelData {
    label: string;
    category: string;
}

export default class GTMOverviewFilterAddModel extends GTMBaseModel {
    public static parseToGTMData({
        label,
        category
    }: GTMOverviewFilterAddModelData): GTMOverviewFilterAddModelReturnType {
        return {
            ...GTMBaseModel.getBaseData(),
            ga4_property: 'cro_event',
            ga4_event_name: 'overview_filter_add',
            filter_label: label,
            filter_group: category
        };
    }
}
